import React, { useState, useRef } from 'react';
import { Tabs, Tab, styled, Button } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import KOCalendar from './KOCalendar';
import NormalCalendar from './NormalCalendar';
import { labelMappings } from '../../../utils/utils';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import { updateSavedCalendar, updateisActivePeriodSaved, updateActivePeriodCustomDates, updateActivePeriodDays, updateActivePeriodMonths, updateActivePeriodSkip, updateActivePeriodWeeks, updateDateStartEnd, updateNDaysFromActivation } from '../../../../../stateManagement/actions/manageCouponActions';
import CouponBox from '../../CouponBox';
import SkipThisStep from './SkipThisStep';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useCouponAlert } from '../../../context/CouponAlert';
import ActivePeriodSelectionTable from './ActivePeriodSelectionTable';
import store from "../../../../../../src/stateManagement/store";
import { monthIndexMapper, weekIndexMapper, dayIndexMapper, indexMonthMapper, indexWeekMapper, indexDayMapper } from "./RecurrenceService"
import {applyNDays} from "../MarketDetails/configData";


const StyledCalendarTabs = styled((props: any) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator_date': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'grey',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '30%',
    backgroundColor: 'var(--coupon-dark-blue)'
  },
});
interface StyledCalendarTabProps {
  isSelected: boolean;
  // onClick: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  theme?: any;
}
const StyledCalendarTab = styled(Tab)<StyledCalendarTabProps>(({ theme, isSelected }) => ({
  textTransform: 'none',
  marginRight: '5px',
  borderRadius: '5px',
  fontSize: '17px',
  width: '210px',
  fontFamily: "poppins",
  color: isSelected ? '#24c6b1' : '#909090',
  fontWeight: isSelected ? 'bold' : 'normal',
  backgroundColor: isSelected ? '#f3fcfb' : '#f2f2f2',
  padding: "0px 45px !important",
  height: "5px",
  cursor: 'pointer',
}));

function CalendarToggle() {
  const { recurrence } = store.getState()?.manageCoupons?.data;

  const monthIndexMap = monthIndexMapper();
  const weekIndexMap = weekIndexMapper();
  const dayIndexMap = dayIndexMapper();
  const indexMonthMap = indexMonthMapper();
  const indexWeekMap = indexWeekMapper();
  const indexDayMap = indexDayMapper();

  const initialValState = {
    days: Array.isArray(recurrence.activePeriodDays) ? recurrence.activePeriodDays.map((index: number) => indexDayMap[index]) : [],
    months: Array.isArray(recurrence.activePeriodMonths) ? recurrence.activePeriodMonths.map((index: number) => indexMonthMap[index]) : [],
    dates: Array.isArray(recurrence.activePeriodCustomDates) ? recurrence.activePeriodCustomDates : [],
    weeks: Array.isArray(recurrence.activePeriodWeeks) ? recurrence.activePeriodWeeks.map((index: number) => indexWeekMap[index]) : []
  };
  const emptyValState = {
    days: [],
    months: [],
    dates: [],
    weeks: []
  };


  const [currentTab, setCurrentTab] = useState<string>(recurrence?.savedCalendar !== "" ? recurrence?.savedCalendar : "0");
  const tabsContentRef = useRef<HTMLDivElement>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const successMethodRef = useRef<() => void>(() => { });
  const [skipCalendarStep, setSkipCalendarStep] = useState(useSelector((state: any) => Boolean(state?.manageCoupons?.data?.recurrence?.skipActivePeriod) || false));
  const [daysFromActivation, setDaysFromActivation] = useState(recurrence?.nDaysFromActivation !== "" ? recurrence?.nDaysFromActivation : "");
  const [isDelete, setIsDelete] = useState<boolean>(recurrence.isActivePeriodSaved ?? false);
  const [savedNDays, setSavedNDays] = useState<boolean>(false);
  const [savedActivePeriod, setSavedActivePeriod] = useState<boolean>(recurrence.isActivePeriodSaved ?? false);
  const { startDate, endDate, } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence?.dateStartEnd);

  const { showAlert } = useCouponAlert();
  const [val, setVal] = useState<{ [key: string]: string[] }>(
    initialValState
  );


  /**
   * this function handels the toggle between the calendars
   * it resets and sets the selected values in redux based on the current toggle
   * @param event 
   * @param newValue 
   * @returns 
   */
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (newValue === currentTab) {
      return;
    }
    else {
      if (currentTab === "0") {
        if (!(recurrence.activePeriodDays.length > 0 ||
          recurrence.activePeriodMonths.length > 0 ||
          recurrence.activePeriodCustomDates.length > 0 ||
          recurrence.activePeriodWeeks.length > 0)
        ) {
          {
            setCurrentTab(newValue);
            return;
          }
        }
      }
      if (currentTab === "1") {
        if ((recurrence.nDaysFromActivation === "")) {
          setCurrentTab(newValue);
          return;
        }
      }
      setOpenModal(true);
      successMethodRef.current = () => {
        console.log("this is toggles");
        if (newValue === "0") {
          updateisActivePeriodSaved(false);
          setDaysFromActivation("");
          updateNDaysFromActivation("");
          setSavedNDays(false);
          setSavedActivePeriod(false);
          setIsDelete(false);
          setVal(initialValState);
          updateActivePeriodDays([]);
          updateActivePeriodWeeks([]);
          updateActivePeriodMonths([]);
          updateActivePeriodCustomDates([]);
          updateDateStartEnd("startDate", startDate);
          updateDateStartEnd("endDate", endDate);
        }
        if (newValue === "1") {
          updateisActivePeriodSaved(false);
          updateNDaysFromActivation("");
          setDaysFromActivation("");
          setSavedNDays(false);
          setSavedActivePeriod(false);
          setIsDelete(false);
          setVal(initialValState);
          updateActivePeriodDays([]);
          updateActivePeriodWeeks([]);
          updateActivePeriodMonths([]);
          updateActivePeriodCustomDates([]);
          updateDateStartEnd("startDate", startDate);
          updateDateStartEnd("endDate", endDate);
        }
        setCurrentTab(newValue);
      }
    }
  };

  /**
   * this function skips he active period steps
   */
  const handleSkipCalendarStep = () => {
    if (skipCalendarStep) {
      setSkipCalendarStep(false);
      updateActivePeriodSkip(false);
    }
    else {
      setVal(initialValState);
      setIsDelete(false);
      setSkipCalendarStep(true);
      updateActivePeriodSkip(true);
      updateActivePeriodDays([]);
      updateActivePeriodWeeks([]);
      updateActivePeriodMonths([]);
      updateActivePeriodCustomDates([]);
      updateNDaysFromActivation("");
      setDaysFromActivation("");
      updateisActivePeriodSaved(false);
      setSavedNDays(false);
    }
  };


  /**
   * 
   * @param updatedState it handel the change in n days from activation
   */
  const handleDaysChange = (updatedState: string) => {
    setDaysFromActivation(updatedState);
    updateNDaysFromActivation(updatedState);
  };


  /**
   * this funciton handels the saving of the active period section
   * it maos maps the selected values to there indexes and
   * it sets the redux states for the saved calendar type
   * @returns 
   */
  const handleActivePeriodSave = () => {
    if (currentTab === "1") {
      if (daysFromActivation !== undefined && daysFromActivation === "") {
        showAlert("Cannot Save Empty Active Periods", 'warning')
        console.log("Cannot Save Empty Active Periods", 'warning')
        return;
      }
      updateisActivePeriodSaved(true);
      updateSavedCalendar("1");
      setIsDelete(true);
      setSavedNDays(true);
      updateActivePeriodDays([]);
      updateActivePeriodWeeks([]);
      updateActivePeriodMonths([]);
      updateActivePeriodCustomDates([]);
      setVal(emptyValState)
    }
    else if (currentTab === "0") {
      const convertedMonthIndexes = val["months"].map((monthString: string) => monthIndexMap[monthString]);
      const convertedDayIndexes = val["days"].map((dayString: string) => dayIndexMap[dayString]);
      const convertedWeekIndexes = val["weeks"].map((weekString: string) => weekIndexMap[weekString]);
      if (convertedMonthIndexes.length === 0 && convertedDayIndexes.length == 0 && convertedWeekIndexes.length == 0 && val["dates"].length===0) {
        showAlert("Cannot Save Empty Active Periods", 'warning')
        return;
      }
      updateSavedCalendar("0");
      updateisActivePeriodSaved(true);
      setIsDelete(true);
      setSavedActivePeriod(true);
      updateActivePeriodDays(convertedDayIndexes);
      updateActivePeriodWeeks(convertedWeekIndexes);
      updateActivePeriodMonths(convertedMonthIndexes);
      updateActivePeriodCustomDates(val["dates"]);
    }
  }


  /**
   * this function handel  the deletion of the saved calendar
   * it sets the redux state to empty for the saved calendar
   */
  const handleDelete = () => {
    if (currentTab === "1") {
      updateSavedCalendar("");
      updateisActivePeriodSaved(false);
      setIsDelete(false);
      setSavedNDays(false);
      setDaysFromActivation("");
      updateNDaysFromActivation("");
      const currentDate = new Date();
      if (startDate !== null && startDate !== "") {
        updateDateStartEnd("startDate", dayjs(currentDate).format("YYYY-MM-DDTHH:mm:ss"));
      }
      if (startDate === null || startDate === "") {
        updateDateStartEnd("startDate", dayjs(currentDate).format("YYYY-MM-DDTHH:mm:ss"));
      }
    }
    else if (currentTab === "0") {
      updateActivePeriodDays([]);
      updateActivePeriodWeeks([]);
      updateActivePeriodMonths([]);
      updateActivePeriodCustomDates([]);
      updateSavedCalendar("");
      updateisActivePeriodSaved(false);
      setVal(emptyValState);
      setIsDelete(false);
      setSavedActivePeriod(false);
    }
  }

  /**
   * 
   * it sets the selected values to a state
   * @param updatedVal 
   */
  const handleValChange = (updatedVal: React.SetStateAction<{ [key: string]: string[] }>) => {
    setVal(prevVal => {
      const newState = typeof updatedVal === 'function' ? updatedVal(prevVal) : updatedVal;
      return { ...prevVal, ...newState };
    });

  };

  const {couponEditType} = useSelector((state:any)=>state.manageCoupons?.data);


  console.log('ct:', typeof currentTab);

  return (
    <CouponBox disabled={skipCalendarStep} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'active-period'} style={{ color: 'inherit' }} /><SkipThisStep onClick={handleSkipCalendarStep} /></>}>


      <div className={`${couponEditType === "edit" ? 'recurrence-blurred-uneditable' : ''}`} style={{ height: '100%' }}>
        <TabContext value={currentTab}>
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ padding: "15px 0px 5px 25px", display: "flex", justifyContent: "space-between" }}>
              {/* <CalendarTabsContainer> */}
              <span style={{display: 'flex',gap: '5px',backgroundColor: '#f2f2f2',width: 'fit-content',borderRadius: "5px",padding: '3px 0px 3px 5px'}}>
                <StyledCalendarTabs variant="fullWidth" value={currentTab} onChange={handleChange}>
                  {/* // onChange={handleChange} */}
                  {/* <span> */}
                  <StyledCalendarTab value={"0"} isSelected={currentTab === "0"} label={<CouponConfigurableLabel text='ko-calendar' style={{ cursor: 'pointer', color: 'inherit' }} />} />
                  {/* </span> */}
                  {/* <span> */}
                  {applyNDays() && <StyledCalendarTab value={"1"} isSelected={currentTab === "1"} label={<CouponConfigurableLabel text='n-days' style={{ cursor: 'pointer', color: 'inherit' }} />} />}
                  {/* </span> */}
                </StyledCalendarTabs>
                </span>
              {/* </CalendarTabsContainer> */}
              {isDelete ?
                <Button onClick={handleDelete} size='small' style={{ marginRight: "24px", width: "95px", height: "45px" }} className='applicable-single-slab-delete-button' startIcon={<DeleteIcon />}>
                  Delete
                </Button> :
                <div className="sku-group-selector-action-btn-wrapper" >
                  <Button onClick={handleActivePeriodSave} variant='contained' className='sku-group-save-btn' style={{ marginRight: "24px", width: "95px", height: "45px" }} size='small' startIcon={<DoneIcon />} >{'Save'}</Button>
                </div>
              }
            </div>
            <div className="define-coupon-tab-content" style={{ flex: 1, overflowY: 'auto' }} ref={tabsContentRef}>
              <TabPanel tabIndex={0} value={"0"}>
                {recurrence?.isActivePeriodSaved || isDelete && currentTab === "0" ?
                  <ActivePeriodSelectionTable activePeriodData={val} />
                  : <></>}
                <KOCalendar val={val} setVal={handleValChange} disableSelection={savedActivePeriod} isDeleted={isDelete} />
              </TabPanel>
              <TabPanel tabIndex={1} value={"1"}>
                <NormalCalendar disableTextField={savedNDays} daysFromActivation={daysFromActivation} setDaysFromActivation={handleDaysChange} />
              </TabPanel>
            </div>
          </div>
        </TabContext>
        <ConfirmationPopUp
          message={labelMappings["RESET_DEPENDENT_DATA"]}
          openConfirmModal={openModal}
          setOpenConfirmModal={setOpenModal}
          successMethod={successMethodRef.current}
        />
      </div>
    </CouponBox >
  );
}

export default CalendarToggle;